import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Carousel from '../../components/Carousel';
import DefaultCard from '../../components/DefaultCard';
import {
  HwDashboardProvider
} from '../../providers/hwDashboard';
import { formatDate } from '../../utils/utils';
import Tools from '../widgets/dashboards/Tools';
import Sharepoint from '../widgets/dashboards/Sharepoint';
import PromoAds from '../widgets/dashboards/PromoAds';



const HwDashboardView = () => {
  
  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      
    <Row>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-12">
          <DefaultCard
            className="h-100 flex-column flex-sm-row "
            variant="blue-motif"
            leftHeading={
              <div className="text-sm-20-lg-32">Welcome to Access Point</div>
            }
            leftSubheading={
              <div className="text-sm-12-lg-14 fw-light mb-7">
                The power of admin at your fingertips
              </div>
            }
            
          />
        </Col>
       
      </Row>

      <Row className="d-flex justify-content-between">
        <Col
          className={'d-flex flex-column pt-lg-8 col-12 col-lg-8 mt-10 mt-lg-8'}
        >
          {<Tools
           />}
        </Col>
        <Col className="pe-lg-0 mt-12 mt-lg-8 pt-lg-8 col-12 col-lg-4">
          <Sharepoint className="p-0 pe-5" />
        </Col>
      </Row>

      

      <Row className="m-0 p-0">
        <PromoAds />
      </Row>
    </Container>
  );
};

const HwDashboard = () => {
  return (
    <HwDashboardProvider>
      <HwDashboardView />
    </HwDashboardProvider>
  );
};

export default HwDashboard;
